import { render, staticRenderFns } from "./ClientePerfilView.vue?vue&type=template&id=fe32d33e"
import script from "./ClientePerfilView.vue?vue&type=script&lang=js"
export * from "./ClientePerfilView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports